import dateFormat from 'dateformat';

export function isDateOnlyEqual(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function parseDate<TValue extends string | (string | undefined)>(value: TValue): TValue extends undefined ? Date | undefined : Date;
export function parseDate(value?: string): Date | undefined {
  if (!value) {
    return undefined;
  }

  return new Date(value);
}

export function formatDate(date: Date | undefined, format: 'short' | 'ISOWithoutTimeZone'): string;
export function formatDate<TValue extends Date | (Date | undefined)>(date: TValue): TValue extends undefined ? string | undefined : string;

export function formatDate(date: Date | undefined, format: 'short' | 'ISOWithoutTimeZone' = 'ISOWithoutTimeZone'): string {
  if (date === undefined) {
    return 'No date';
  }

  if (format === 'short') {
    return dateFormat(date, 'dd/mm/yyyy');
  }

  const tzDifferenceInMilliseconds = -(new Date().getTimezoneOffset() * 60 * 1000);
  const dateWithOffset = new Date(date.getTime() + tzDifferenceInMilliseconds);
  const result = dateWithOffset.toISOString().slice(0, -1);

  return result;
}
